import React, { createContext, useContext } from "react";
import { Audio, OffthreadVideo } from "remotion";

/** Preview-only: iOS Safari ignores a media element's volume, so the Player mixes through the Web Audio API there. Off during renders. */
export const WebAudioCtx = createContext(false);
export const useWebAudio = (): boolean => useContext(WebAudioCtx);
/** Preview-only: a phone's light mode. Full-screen blurs, glass and motion-blur transitions are skipped there; the render never sets it. */
export const LiteCtx = createContext(false);
export const useLite = (): boolean => useContext(LiteCtx);

type AudioProps = React.ComponentProps<typeof Audio>;
type VideoProps = React.ComponentProps<typeof OffthreadVideo>;
/** `<Audio>` that honours its volume on iOS as well. */
export const PAudio: React.FC<AudioProps> = (props) => <Audio {...props} useWebAudioApi={useWebAudio() || props.useWebAudioApi} />;
/** `<OffthreadVideo>` that honours its volume on iOS as well. */
export const PVideo: React.FC<VideoProps> = (props) => <OffthreadVideo {...props} useWebAudioApi={useWebAudio() || props.useWebAudioApi} />;
